<div
  class="flex flex-col items-center gap-6 w-full"
  style="font-family: var(--feedback-font-family)"
>
  <app-dynamic
    componentName="SvgIcon"
    [props]="{ name: config().icon, size: '56', color: config().iconColor }"
  />

  <app-dynamic
    componentName="DynamicText"
    [props]="{ config: headerTextConfig() }"
  />

  @if (config().subhead) {
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: subheadTextConfig() }"
    />
  }
  @if (config().primaryDetails || config().secondaryDetails) {
    <div class="flex flex-col gap-3 w-full">
      @if (config().primaryDetails) {
        <app-dynamic
          componentName="DetailCard"
          [props]="{ config: config().primaryDetails }"
        />
      }
      @if (config().secondaryDetails) {
        <app-dynamic
          componentName="DetailCard"
          [props]="{ config: config().secondaryDetails }"
        />
      }
    </div>
  }
</div>
